module.exports = __webpack_public_path__ + "static/media/gestioneRichiesteTCB.415a9a5f.png";